import { useEffect, useRef } from 'react'
import { Event } from 'typings'
import { useAnalytics } from 'use-analytics'

type Props = {
  event: Event
  enable: boolean
  payload?: any
  reset?: boolean
}

export function useTrack(props: Props) {
  const { event, enable, payload, reset } = props

  const { track } = useAnalytics()

  const trackedRef = useRef(false)

  useEffect(() => {
    if (!trackedRef.current && enable) {
      track(event, payload)
      trackedRef.current = true
    }

    if (trackedRef.current && reset) {
      trackedRef.current = false
    }
  }, [event, payload, reset, enable, track])
}
